module.exports = __webpack_public_path__ + "img/chicken-fall-failed.c1d9336a.gif";